import Marquee from "./Marquee";
import { MarqueeProps } from "./Marquee/interface";

export { type MarqueeProps, Marquee as default };
